import { render } from "./TheAdminPatientExpedientCreate.vue?vue&type=template&id=405d526d&ts=true"
import script from "./TheAdminPatientExpedientCreate.vue?vue&type=script&lang=ts"
export * from "./TheAdminPatientExpedientCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__